// index.js or main entry point
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import AuthInterceptor from './components/AuthInterceptor';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AuthInterceptor />
      <App />
    </AuthProvider>
  </React.StrictMode>
);